import {
  ActionIcon,
  Box,
  Flex,
  Image,
  Radio,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { FC, useState } from "react";
import { MoneySourceProps } from "./types";
import IconCopy from "@/assets/images/pngs/elements-copy.png";
import { useTranslation } from "react-i18next";

const MoneySource: FC<MoneySourceProps> = ({ source, onChange, isSelected }) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);

  // Use getMoneySource API fields directly — no secondary checkSourceAccount call needed
  const displayNumber = source.sourceNumber || source.cardMask || source.sourceObjectNumber || "";
  const displayName = source.sourceName || source.displayName || "";
  const balanceDisplay = source.availableBalanceDisplay || source.availableBalance || "—";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(displayNumber);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("copy failed", err);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      onClick={() => onChange(source.id)}
    >
      <Flex align="center" gap={10}>
        <Radio checked={isSelected} onChange={() => onChange(source.id)} />
        <Stack spacing={0}>
          <Text color="#5E656B" fw={400} fz="xs">
            {source.sourceTypeName || source.sourceType}
          </Text>
          <Flex align="center">
            <Text color="#000" fw={700}>
              {displayNumber || "—"}
            </Text>
            {displayNumber && (
              <Tooltip label={copied ? "Copied" : "Copy"} withArrow>
                <ActionIcon
                  variant="transparent"
                  onClick={(e) => { e.stopPropagation(); handleCopy(); }}
                  aria-label="Copy account number"
                  size={20}
                  style={{ padding: 0, marginLeft: 4 }}
                >
                  <Image src={IconCopy} alt="Copy Icon" width={16} height={16} />
                </ActionIcon>
              </Tooltip>
            )}
          </Flex>
          <Text fw={400} fz="sm" color="#5E656B">
            {displayName}
          </Text>
        </Stack>
      </Flex>
      <Box>
        <Text c="#5E656B" fw={400} fz="xs" align="right">
          {t("AVAIABLE_BALANCE")}
        </Text>
        <Text c="#0171BB" fw={700}>
          {balanceDisplay}
        </Text>
      </Box>
    </Box>
  );
};

export default MoneySource;
